var _defs, _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperatureWarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warm",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 80,
    viewBox: "0 0 18 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.139,
    stopColor: "#ec1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#ed2225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#f2662a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#ca7454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#7093b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#4ca0d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#45a1da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#2ca5e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#18a9e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#0babeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#02aded"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00adee"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M18,71.25A8.873,8.873,0,0,1,9,80a8.88,8.88,0,0,1-9-8.75,8.652,8.652,0,0,1,4.2-7.39V4.66A4.728,4.728,0,0,1,9,0a4.73,4.73,0,0,1,4.81,4.66V63.85A8.694,8.694,0,0,1,18,71.25Z",
    fill: "#58595b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M8.81,13.47h.38a3.325,3.325,0,0,1,3.32,3.32V68.48A3.325,3.325,0,0,1,9.19,71.8H8.81a3.325,3.325,0,0,1-3.32-3.32V16.79A3.318,3.318,0,0,1,8.81,13.47Z",
    fill: "url(#linear-gradient)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_349",
    "data-name": "Ellipse 349",
    cx: 7.58,
    cy: 7.37,
    rx: 7.58,
    ry: 7.37,
    transform: "translate(1.42 63.88)",
    fill: "#ec1c24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureWarm);
export default __webpack_public_path__ + "static/media/temperature_warm.4e91b1ef1068488a1ba4218fc9799006.svg";
export { ForwardRef as ReactComponent };